import React from 'react';
import { MBUrgentBannerWithModal } from '@shared/scenes/chat/urgent/components';
import { useDispatch, useSelector } from '@shared/store';
import * as Actions from '../store/actions';

interface MBUrgentBannerProps {
  count: number;
  draftId: string;
}

export function MBUrgentBanner({ count, draftId }: MBUrgentBannerProps) {
  const urgent = useSelector(state => state.chatInput.urgentFromDraftId[draftId]);
  const dispatch = useDispatch();
  const removeSendAsUrgent = React.useCallback(
    () => Actions.disableUrgent(draftId)(dispatch),
    [draftId, dispatch],
  );

  if (!urgent) {
    return null;
  }
  // TODO(fant): figure out how to calculate mentionable users
  return (
    <MBUrgentBannerWithModal
      count={count}
      autoShowModal
      onRemoveSendAsUrgent={removeSendAsUrgent}
    />
  );
}
